import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MIATableModel, ApiPagination } from '@mobileia/core';
import { BaseTableService } from 'src/app/services/base-table.service';
import { AlertService } from 'src/app/services/alert.service';
import { PageEvent } from '@angular/material/paginator';
import { PaymentInstallment } from 'src/app/entities/payment-installment';

@Component({
  selector: 'app-base-table',
  templateUrl: './base-table.component.html',
  styleUrls: ['./base-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BaseTableComponent<T> implements OnInit {

  isSending = false;
  isLoading = true;
  tableModel = new MIATableModel();
  displayedColumns = [];
  configColumns = [];
  dataItemsTable = new ApiPagination<T>();
  dataItemsTableS = new ApiPagination<T>();
  service: BaseTableService<any>;
  filterSearch = '';
  filterSearchCodigo = '';
  filterSearchNombre = '';
  filterSearchApellido = '';
  filterSearchId = '';
  filterSearchExternalCode = '';
  percent = 0.00;
  compareString = '';
  comparePosition = 0;
  
  constructor(
    protected alertService: AlertService
  ) { }

  ngOnInit(): void {
  }

  loadItems(NumberPrice) {
    this.isLoading = true;
    this.service.list(this.tableModel).toPromise().then(data => {
      this.isLoading = false;
      if (!data.success) {
        this.alertService.showError('Error!', data.error.message);
        return;
      }
      this.dataItemsTable = data.response;
      try {
        for(let i = 0; i <100; i++)
        {
          const values = Object.values(this.dataItemsTable[i]);
          this.percent = parseFloat(String(values[3])) / 100;
          var priceTotal = parseFloat(NumberPrice + (NumberPrice * this.percent)).toFixed(2);
          values[3] = '$' + priceTotal;
          var splitted = Number(priceTotal) / Number(String(values[1]).split(" ", 1));
          values[0] = '$' + parseFloat(String(splitted)).toFixed(2);
          if (String(values[1]).length < 9)
            this.dataItemsTable[i] = { id: values[0], title: values[1], installment: values[2], percent: values[3], type: values[4], sort: String(values[4]) + '0' + String(values[1]) };
          else
            this.dataItemsTable[i] = { id: values[0], title: values[1], installment: values[2], percent: values[3], type: values[4], sort: String(values[4]) + String(values[1]) };
        }
      }
      catch (err) {}
      this.dataItemsTableS = this.dataItemsTable;

      try {
        for(let J = 1; J <100; J++)
        {
          const values = Object.values(this.dataItemsTableS[J]);
          this.compareString = String(values[5]);
          this.comparePosition = J - 1;
          const values1 = Object.values(this.dataItemsTableS[this.comparePosition]);
          while (this.comparePosition >= 0 && String(Object.values(this.dataItemsTableS[this.comparePosition])[5]) > this.compareString)
          {
            this.dataItemsTableS[this.comparePosition +1] = this.dataItemsTableS[this.comparePosition];
            this.comparePosition = this.comparePosition - 1;
          }
          this.dataItemsTableS[this.comparePosition +1]   = { id: values[0], title: values[1], installment: values[2], percent: values[3], type: values[4], sort: values[5] };
        }
      }
      catch (err) {}


      this.dataItemsTableS;
    }).catch(error => {
      this.isLoading = false;
      this.alertService.showError('Error!', error);
    });
  }

  onRemove(item: any) {
    this.isLoading = true;
    this.service.remove(item.id).toPromise().then(data => {
      this.isLoading = false;
      if (data.success) {
        this.loadItems(Number);
      }
    });
  }

  openItem(item: T) { }

  onPageChange(event: PageEvent) {
    this.tableModel.itemPerPage = event.pageSize;
    this.tableModel.pageCurrent = event.pageIndex + 1;
    this.loadItems(Number);
  }
}
